export default [
  {
    path: 'variety-list',
    name: 'VarietyList',
    meta: {
      isDynamic: true,
      id: '小程序商品库',
      inTab: true
    },
    component: () => import('@/views/Variety/VarietyList/VarietyList.vue')
  },
  {
    path: 'save-variety',
    name: 'SaveVariety',
    meta: {
      id: '新增品种'
    },
    component: () => import('@/views/Variety/SaveVariety/SaveVariety.vue')
  }
];
